module.exports = __webpack_public_path__ + "static/media/screen-sl.1fe5a7e4.svg";